import { render } from "./DigitalHoldingsModule.vue?vue&type=template&id=ee9fe834&scoped=true"
import script from "./DigitalHoldingsModule.vue?vue&type=script&lang=js"
export * from "./DigitalHoldingsModule.vue?vue&type=script&lang=js"

import "./DigitalHoldingsModule.vue?vue&type=style&index=0&id=ee9fe834&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ee9fe834"

export default script